import { environment } from "../../../environments/environment";

/**
 * Build-time deployment surface policy. Auto-optimization remains available
 * for local/staging validation but is absent from production route and menu
 * tables until its production release lane is explicitly completed.
 */
export function isAutoOptimizationSurfaceEnabled(production: boolean): boolean {
  return !production;
}

export const AUTO_OPTIMIZATION_SURFACE_ENABLED =
  isAutoOptimizationSurfaceEnabled(environment.production);
